import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import AgentQueryModel from '../models/AgentQueryModel';
import AgentModel from '../models/AgentModel';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';

interface agentSearchState {
    query: AgentQueryModel,
    searchResults: AgentModel[],
    agentSearchKeyword: string,
    triggerSearch: number,
    selectedAgents: AgentModel[],
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedAgents: AgentModel[],
}

const initialState: agentSearchState = {
    query: {
        agentNames: [],
        portNames: [],
        countries: [],
        cargoesHandling: [],
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as AgentQueryModel,
    searchResults: [],
    agentSearchKeyword: "",
    selectedAgents: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedAgents: []
}

export const AgentSearchSlice = createSlice({
    name: "AgentSearch",
    initialState,
    reducers: {
        setAgentNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.agentNames = action.payload;
        },
        setPortNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.portNames = action.payload;
        },
        setCountries: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.countries = action.payload;
        },
        setCargoesHandling: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.cargoesHandling = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setAgentSearchResults: (state, action: PayloadAction<AgentModel[]>) => {
            state.searchResults = action.payload;
        },
        setTriggerAgentSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setAgentSearchKeyword: (state, action: PayloadAction<string>) => {
            state.agentSearchKeyword = action.payload;
        },
        setDatatableSelectedAgentIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setAgentquery: (state, action: PayloadAction<AgentQueryModel>) => {
            state.query = action.payload;
        },
        resetAgentSearch: (state) => {
            state.query = initialState.query;
        },
        setSelectedAgents: (state, action: PayloadAction<AgentModel[]>) => {
            state.selectedAgents = action.payload;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedAgents: (state, action: PayloadAction<AgentModel[]>) => {
            state.checkedAgents = action.payload;
        },
    }
});

export const AgentSearchSelector = createSelector(
    (state: RootState) => state.agentSearch,
    (data) => data
);

export const {
    setCountries,
    setAgentNames,
    setPortNames,
    setCargoesHandling,
    setOrderBy,
    setAgentSearchKeyword,
    setOrderDirection,
    setAgentSearchResults,
    setTriggerAgentSearch,
    setDatatableSelectedAgentIndex,
    setSearchResultTotalRecord,
    setAgentquery,
    resetAgentSearch,
    setSelectedAgents,
    setTriggerFocusCompanyName,
    setCheckedAgents
} = AgentSearchSlice.actions;

export default AgentSearchSlice.reducer;